import { HttpContextToken } from '@angular/common/http';

export const REFRESH_TRIED = new HttpContextToken<boolean>(() => false);
